import {getAxiosInstance} from "../../../np-rest/rest";
import {snackActions} from "../../../sc-utilities/SnackBar";

export const onFetchHeadphoneProductAuditRecordsCount = (filterData) => {
    const rest = getAxiosInstance();

    return async () => {
        try {
            let countRes = await rest.post("/product-audit-record/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                return countRes.data.result.data;
            }
            snackActions.snackBar({
                message: `${countRes && countRes.data && countRes.data.message ? countRes.data.message : "Cannot fetch audit records."}`,
                options: {
                    variant: "warning",
                },
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch audit records."}`,
                options: {
                    variant: "error",
                },
            });
            return null;
        }
    };
};

export const onFetchHeadphoneProductAuditRecords = (filterData) => {
    const rest = getAxiosInstance();

    return async () => {
        try {
            let countRes = await rest.post("/product-audit-record/list", filterData);
            if (countRes.data && countRes.data.succeeded) {
                return countRes.data.result.data;
            }
            snackActions.snackBar({
                message: `${countRes && countRes.data && countRes.data.message ? countRes.data.message : "Cannot fetch audit records."}`,
                options: {
                    variant: "warning",
                },
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch audit records."}`,
                options: {
                    variant: "error",
                },
            });
            return null;
        }
    };
};

export const bulkDeleteHeadphoneProductAuditRecords = (params) => {
    const rest = getAxiosInstance();

    return async () => {
        try {
            const res = await rest.post("/product-audit-record/bulk-delete", params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully deleted audit records.`,
                    options: {
                        variant: "success",
                    },
                });
                return;
            }
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete audit records."
                }`,
                options: {
                    variant: "warning",
                },
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: "error",
                },
            });
            return null;
        }
    };
};